import { AppMessage } from '@/common/components';
import { FC, memo, ReactElement, useCallback } from 'react';

import { FallbackedLayout } from '@/common/layouts';
import { messageOnError } from '@/common/utils';

import { useGenerateSitemapMutation, useGetByIdSitemapQuery } from '@/modules/Domains';

import { SitemapDossierView } from './SitemapDossierView';

interface Props {
  siteId: string;
  domainId: string;
}

export const SitemapDossierContainer: FC<Props> = memo(({ domainId, siteId }) => {
  const appMessageApi = AppMessage.useControls();

  const {
    data: sitemapData,
    error: sitemapError,
    isLoading: isSitemapLoading,
    isError: isSitemapError,
    refetch: refetchSitemap
  } = useGetByIdSitemapQuery(siteId, domainId)({
    enabled: !!domainId && !!siteId
  });

  const { mutate: generateSitemapMutation, isLoading: isGenerateSitemapLoading } = useGenerateSitemapMutation(siteId, domainId)({
    onSuccess: async () => {
      await refetchSitemap();

      appMessageApi.success(<><span style={{ fontFamily: 'monospace' }}>sitemap</span> згенеровано успішно!</>);
    },
    onError: (err) => {
      messageOnError(err, appMessageApi);
    }
  });

  const handleGenerateSitemap = useCallback(() => {
    generateSitemapMutation();
  }, []);

  return (
    <FallbackedLayout data={ sitemapData } isLoading={ isSitemapLoading } isError={ isSitemapError } error={ sitemapError }>
      {
        (domain): ReactElement => (
          <SitemapDossierView
            isGenerateSitemapLoading={ isGenerateSitemapLoading }
            handleGenerateSitemap={ handleGenerateSitemap }
            sitemapLastGeneratedAt={ domain.sitemapLastGeneratedAt }
            sitemapContent={ domain.sitemap }
          />
        )
      }
    </FallbackedLayout>
  );
});
